export default __webpack_public_path__ + "static/media/VETO Adult Dry Dog Food.0dcf1d9e.png";